// import React, {
//   useCallback,
//   useEffect,
//   useState,
// } from "react";

// import shopService from "../services/shopService";

// const Computers = () => {
//   const [computers, setComputers] =
//     useState([]);

//   const [loading, setLoading] =
//     useState(true);

//   const [creating, setCreating] =
//     useState(false);

//   const [message, setMessage] =
//     useState("");

//   const [error, setError] =
//     useState("");

//   const [form, setForm] = useState({
//     computer_code: "",
//     password: "",
//   });

//   const [passwordModal, setPasswordModal] =
//     useState(null);

//   const [newPassword, setNewPassword] =
//     useState("");

//   const [passwordUpdating, setPasswordUpdating] =
//     useState(false);


//   // ============================================================
//   // LOAD COMPUTERS
//   // ============================================================

//   const loadComputers = useCallback(
//     async () => {
//       try {
//         setLoading(true);
//         setError("");

//         const data =
//           await shopService.getComputers();

//         setComputers(
//           Array.isArray(data?.computers)
//             ? data.computers
//             : []
//         );
//       } catch (err) {
//         console.error(
//           "Load Computers Error:",
//           err
//         );

//         setError(
//           err?.response?.data?.message ||
//             "Unable to load computers."
//         );
//       } finally {
//         setLoading(false);
//       }
//     },
//     []
//   );


//   useEffect(() => {
//     loadComputers();
//   }, [loadComputers]);


//   // ============================================================
//   // FORM CHANGE
//   // ============================================================

//   const handleChange = (e) => {
//     const {
//       name,
//       value,
//     } = e.target;

//     setForm((prev) => ({
//       ...prev,

//       [name]:
//         name === "computer_code"
//           ? value.toUpperCase()
//           : value,
//     }));
//   };


//   // ============================================================
//   // CREATE COMPUTER
//   // ============================================================

//   const handleCreate = async (e) => {
//     e.preventDefault();

//     setMessage("");
//     setError("");

//     const computerCode =
//       form.computer_code
//         .trim()
//         .toUpperCase();

//     const password =
//       form.password;

//     if (!computerCode) {
//       setError(
//         "Computer ID is required."
//       );
//       return;
//     }

//     if (password.length < 4) {
//       setError(
//         "Password must be at least 4 characters."
//       );
//       return;
//     }

//     try {
//       setCreating(true);

//       const data =
//         await shopService.createComputer({
//           computer_code:
//             computerCode,

//           password,
//         });

//       setMessage(
//         data?.message ||
//           "Computer created successfully."
//       );

//       setForm({
//         computer_code: "",
//         password: "",
//       });

//       await loadComputers();
//     } catch (err) {
//       console.error(
//         "Create Computer Error:",
//         err
//       );

//       setError(
//         err?.response?.data?.message ||
//           "Unable to create computer."
//       );
//     } finally {
//       setCreating(false);
//     }
//   };


//   // ============================================================
//   // STATUS
//   // ============================================================

//   const handleStatus = async (
//     computer
//   ) => {
//     const newStatus =
//       computer.status === "ACTIVE"
//         ? "BLOCKED"
//         : "ACTIVE";

//     try {
//       setMessage("");
//       setError("");

//       const data =
//         await shopService.updateComputerStatus(
//           computer.id,
//           newStatus
//         );

//       setMessage(
//         data?.message ||
//           "Computer status updated."
//       );

//       await loadComputers();
//     } catch (err) {
//       console.error(
//         "Status Error:",
//         err
//       );

//       setError(
//         err?.response?.data?.message ||
//           "Unable to update status."
//       );
//     }
//   };


//   // ============================================================
//   // OPEN PASSWORD MODAL
//   // ============================================================

//   const openPasswordModal = (
//     computer
//   ) => {
//     setPasswordModal(computer);
//     setNewPassword("");
//     setMessage("");
//     setError("");
//   };


//   // ============================================================
//   // CHANGE PASSWORD
//   // ============================================================

//   const handlePasswordChange =
//     async (e) => {
//       e.preventDefault();

//       if (!passwordModal) {
//         return;
//       }

//       if (newPassword.length < 4) {
//         setError(
//           "Password must be at least 4 characters."
//         );
//         return;
//       }

//       try {
//         setPasswordUpdating(true);
//         setError("");

//         const data =
//           await shopService.changeComputerPassword(
//             passwordModal.id,
//             newPassword
//           );

//         setPasswordModal(null);
//         setNewPassword("");

//         setMessage(
//           data?.message ||
//             "Password changed successfully."
//         );
//       } catch (err) {
//         console.error(
//           "Password Update Error:",
//           err
//         );

//         setError(
//           err?.response?.data?.message ||
//             "Unable to change password."
//         );
//       } finally {
//         setPasswordUpdating(false);
//       }
//     };


//   // ============================================================
//   // DATE
//   // ============================================================

//   const formatDate = (value) => {
//     if (!value) {
//       return "-";
//     }

//     const date = new Date(value);

//     if (
//       Number.isNaN(date.getTime())
//     ) {
//       return "-";
//     }

//     return date.toLocaleString();
//   };


//   return (
//     <div className="min-h-screen bg-slate-100 p-4 md:p-6">
//       <div className="mx-auto max-w-7xl">

//         {/* ================================================= */}
//         {/* HEADER */}
//         {/* ================================================= */}

//         <div className="mb-6">
//           <h1 className="text-2xl font-bold text-slate-900">
//             Computer Management
//           </h1>

//           <p className="mt-1 text-sm text-slate-500">
//             Create and manage fixed
//             computer accounts.
//           </p>
//         </div>


//         {/* ================================================= */}
//         {/* MESSAGE */}
//         {/* ================================================= */}

//         {message && (
//           <div className="mb-4 rounded-lg border border-green-200 bg-green-50 px-4 py-3 text-sm font-medium text-green-700">
//             {message}
//           </div>
//         )}

//         {error && (
//           <div className="mb-4 rounded-lg border border-red-200 bg-red-50 px-4 py-3 text-sm font-medium text-red-700">
//             {error}
//           </div>
//         )}


//         {/* ================================================= */}
//         {/* CREATE COMPUTER */}
//         {/* ================================================= */}

//         <div className="mb-6 rounded-xl bg-white p-5 shadow-sm">
//           <div className="mb-5">
//             <h2 className="text-lg font-semibold text-slate-900">
//               Create Computer
//             </h2>

//             <p className="mt-1 text-sm text-slate-500">
//               Create a fixed Computer ID
//               and password.
//             </p>
//           </div>

//           <form
//             onSubmit={handleCreate}
//             className="grid grid-cols-1 gap-4 md:grid-cols-3"
//           >
//             <div>
//               <label className="mb-2 block text-sm font-medium text-slate-700">
//                 Computer ID
//               </label>

//               <input
//                 type="text"
//                 name="computer_code"
//                 value={
//                   form.computer_code
//                 }
//                 onChange={
//                   handleChange
//                 }
//                 placeholder="PC-05"
//                 autoComplete="off"
//                 className="w-full rounded-lg border border-slate-300 px-4 py-2.5 outline-none transition focus:border-blue-500 focus:ring-2 focus:ring-blue-100"
//               />
//             </div>

//             <div>
//               <label className="mb-2 block text-sm font-medium text-slate-700">
//                 Password
//               </label>

//               <input
//                 type="password"
//                 name="password"
//                 value={
//                   form.password
//                 }
//                 onChange={
//                   handleChange
//                 }
//                 placeholder="Enter password"
//                 autoComplete="new-password"
//                 className="w-full rounded-lg border border-slate-300 px-4 py-2.5 outline-none transition focus:border-blue-500 focus:ring-2 focus:ring-blue-100"
//               />
//             </div>

//             <div className="flex items-end">
//               <button
//                 type="submit"
//                 disabled={creating}
//                 className="w-full rounded-lg bg-blue-600 px-5 py-2.5 font-semibold text-white transition hover:bg-blue-700 disabled:cursor-not-allowed disabled:opacity-60"
//               >
//                 {creating
//                   ? "Creating..."
//                   : "Create Computer"}
//               </button>
//             </div>
//           </form>
//         </div>


//         {/* ================================================= */}
//         {/* COMPUTER LIST */}
//         {/* ================================================= */}

//         <div className="overflow-hidden rounded-xl bg-white shadow-sm">

//           <div className="flex items-center justify-between border-b border-slate-200 px-5 py-4">
//             <div>
//               <h2 className="font-semibold text-slate-900">
//                 Computers
//               </h2>

//               <p className="text-sm text-slate-500">
//                 Total:{" "}
//                 {computers.length}
//               </p>
//             </div>

//             <button
//               type="button"
//               onClick={
//                 loadComputers
//               }
//               className="rounded-lg border border-slate-300 bg-white px-4 py-2 text-sm font-medium text-slate-700 hover:bg-slate-50"
//             >
//               Refresh
//             </button>
//           </div>


//           <div className="overflow-x-auto">
//             <table className="w-full min-w-[850px] text-left">

//               <thead className="bg-slate-50">
//                 <tr>
//                   <th className="px-5 py-3 text-xs font-semibold uppercase text-slate-500">
//                     Sr No
//                   </th>

//                   <th className="px-5 py-3 text-xs font-semibold uppercase text-slate-500">
//                     Computer ID
//                   </th>

//                   <th className="px-5 py-3 text-xs font-semibold uppercase text-slate-500">
//                     Status
//                   </th>

//                   <th className="px-5 py-3 text-xs font-semibold uppercase text-slate-500">
//                     Created
//                   </th>

//                   <th className="px-5 py-3 text-xs font-semibold uppercase text-slate-500">
//                     Actions
//                   </th>
//                 </tr>
//               </thead>


//               <tbody className="divide-y divide-slate-100">

//                 {loading ? (
//                   <tr>
//                     <td
//                       colSpan="5"
//                       className="px-5 py-10 text-center text-slate-500"
//                     >
//                       Loading computers...
//                     </td>
//                   </tr>
//                 ) : computers.length ===
//                   0 ? (
//                   <tr>
//                     <td
//                       colSpan="5"
//                       className="px-5 py-10 text-center text-slate-500"
//                     >
//                       No computers created
//                       yet.
//                     </td>
//                   </tr>
//                 ) : (
//                   computers.map(
//                     (
//                       computer,
//                       index
//                     ) => (
//                       <tr
//                         key={
//                           computer.id
//                         }
//                         className="hover:bg-slate-50"
//                       >
//                         <td className="px-5 py-4 text-sm text-slate-600">
//                           {index + 1}
//                         </td>

//                         <td className="px-5 py-4">
//                           <div className="font-bold text-slate-900">
//                             {
//                               computer.computer_code
//                             }
//                           </div>

//                           <div className="text-xs text-slate-400">
//                             DB ID:{" "}
//                             {
//                               computer.id
//                             }
//                           </div>
//                         </td>

//                         <td className="px-5 py-4">
//                           <span
//                             className={`inline-flex rounded-full px-3 py-1 text-xs font-bold ${
//                               computer.status ===
//                               "ACTIVE"
//                                 ? "bg-green-100 text-green-700"
//                                 : "bg-red-100 text-red-700"
//                             }`}
//                           >
//                             {
//                               computer.status
//                             }
//                           </span>
//                         </td>

//                         <td className="px-5 py-4 text-sm text-slate-600">
//                           {formatDate(
//                             computer.created_at
//                           )}
//                         </td>

//                         <td className="px-5 py-4">
//                           <div className="flex flex-wrap gap-2">

//                             <button
//                               type="button"
//                               onClick={() =>
//                                 openPasswordModal(
//                                   computer
//                                 )
//                               }
//                               className="rounded-lg bg-slate-800 px-3 py-2 text-xs font-semibold text-white hover:bg-slate-900"
//                             >
//                               Change Password
//                             </button>

//                             <button
//                               type="button"
//                               onClick={() =>
//                                 handleStatus(
//                                   computer
//                                 )
//                               }
//                               className={`rounded-lg px-3 py-2 text-xs font-semibold text-white ${
//                                 computer.status ===
//                                 "ACTIVE"
//                                   ? "bg-red-600 hover:bg-red-700"
//                                   : "bg-green-600 hover:bg-green-700"
//                               }`}
//                             >
//                               {computer.status ===
//                               "ACTIVE"
//                                 ? "Block"
//                                 : "Activate"}
//                             </button>

//                           </div>
//                         </td>
//                       </tr>
//                     )
//                   )
//                 )}

//               </tbody>
//             </table>
//           </div>
//         </div>
//       </div>


//       {/* ================================================= */}
//       {/* CHANGE PASSWORD MODAL */}
//       {/* ================================================= */}

//       {passwordModal && (
//         <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4">

//           <div className="w-full max-w-md rounded-xl bg-white p-6 shadow-xl">

//             <h2 className="text-xl font-bold text-slate-900">
//               Change Password
//             </h2>

//             <p className="mt-1 text-sm text-slate-500">
//               Computer:{" "}
//               <strong>
//                 {
//                   passwordModal.computer_code
//                 }
//               </strong>
//             </p>


//             <form
//               onSubmit={
//                 handlePasswordChange
//               }
//               className="mt-5"
//             >
//               <label className="mb-2 block text-sm font-medium text-slate-700">
//                 New Password
//               </label>

//               <input
//                 type="password"
//                 value={
//                   newPassword
//                 }
//                 onChange={(e) =>
//                   setNewPassword(
//                     e.target.value
//                   )
//                 }
//                 autoFocus
//                 autoComplete="new-password"
//                 placeholder="Enter new password"
//                 className="w-full rounded-lg border border-slate-300 px-4 py-2.5 outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-100"
//               />


//               <div className="mt-6 flex justify-end gap-3">

//                 <button
//                   type="button"
//                   onClick={() => {
//                     setPasswordModal(
//                       null
//                     );

//                     setNewPassword(
//                       ""
//                     );
//                   }}
//                   className="rounded-lg border border-slate-300 px-4 py-2 font-medium text-slate-700 hover:bg-slate-50"
//                 >
//                   Cancel
//                 </button>

//                 <button
//                   type="submit"
//                   disabled={
//                     passwordUpdating
//                   }
//                   className="rounded-lg bg-blue-600 px-4 py-2 font-semibold text-white hover:bg-blue-700 disabled:opacity-60"
//                 >
//                   {passwordUpdating
//                     ? "Updating..."
//                     : "Update Password"}
//                 </button>

//               </div>
//             </form>
//           </div>
//         </div>
//       )}

//     </div>
//   );
// };

// export default Computers;









import React, {
  useCallback,
  useEffect,
  useState,
} from "react";

import Navbar from "../components/Navbar";
import Sidebar from "../components/Sidebar";
import shopService from "../services/shopService";
import { toast } from "react-toastify";

const Computers = () => {
  // ============================================================
  // SIDEBAR
  // ============================================================

  const [sidebarOpen, setSidebarOpen] = useState(false);

  const toggleSidebar = () => {
    setSidebarOpen((previous) => !previous);
  };

  const closeSidebar = () => {
    setSidebarOpen(false);
  };

  // ============================================================
  // COMPUTER STATES
  // ============================================================

  const [computers, setComputers] = useState([]);

  const [loading, setLoading] = useState(true);

  const [creating, setCreating] = useState(false);

  const [message, setMessage] = useState("");

  const [error, setError] = useState("");

  const [form, setForm] = useState({
    computer_code: "",
    password: "",
  });

  // ============================================================
  // PASSWORD MODAL
  // ============================================================

  const [passwordModal, setPasswordModal] = useState(null);

  const [newPassword, setNewPassword] = useState("");

  const [passwordUpdating, setPasswordUpdating] =
    useState(false);

  const [transferModal, setTransferModal] = useState(null);
  const [transferAmount, setTransferAmount] = useState("");
  const [transferringCoins, setTransferringCoins] = useState(false);

  const [computerToDelete, setComputerToDelete] = useState(null);
  const [deletingComputer, setDeletingComputer] = useState(false);

  const openTransferModal = (computer) => {
    setTransferModal(computer);
    setTransferAmount("");
  };

  const closeTransferModal = () => {
    setTransferModal(null);
    setTransferAmount("");
  };

  const handleTransferCoins = async (e) => {
    e.preventDefault();
    const amountNum = Number(transferAmount);

    if (!transferModal || !Number.isFinite(amountNum) || amountNum <= 0) {
      toast.error("Please enter a valid coin amount.");
      return;
    }

    try {
      setTransferringCoins(true);
      const res = await shopService.transferToComputer(
        transferModal.id,
        amountNum
      );

      toast.success(res?.message || "Coins transferred successfully!");
      closeTransferModal();
      await loadComputers();
    } catch (err) {
      toast.error(
        err?.response?.data?.message || "Unable to transfer coins to computer."
      );
    } finally {
      setTransferringCoins(false);
    }
  };

  const handleDeleteComputer = async (computer) => {
    if (!computer) return;
    try {
      setDeletingComputer(true);
      const res = await shopService.deleteComputer(computer.id);
      toast.success(res?.message || "Computer deleted successfully.");
      setComputerToDelete(null);
      await loadComputers();
    } catch (err) {
      toast.error(
        err?.response?.data?.message || "Unable to delete computer."
      );
    } finally {
      setDeletingComputer(false);
    }
  };

  const handleResetDeviceLock = async (computer) => {
    if (
      !window.confirm(
        `Reset device lock for Computer ${computer.computer_code}? Next device to login will bind to this ID.`
      )
    ) {
      return;
    }

    try {
      const res = await shopService.resetComputerDeviceBinding(computer.id);
      toast.success(res?.message || "Device lock reset successfully.");
      await loadComputers();
    } catch (err) {
      toast.error(
        err?.response?.data?.message || "Unable to reset device lock."
      );
    }
  };

  // ============================================================
  // LOAD COMPUTERS
  // ============================================================

  const loadComputers = useCallback(async () => {
    try {
      setLoading(true);
      setError("");

      const data = await shopService.getComputers();

      setComputers(
        Array.isArray(data?.computers)
          ? data.computers
          : []
      );
    } catch (err) {
      console.error("Load Computers Error:", err);

      setError(
        err?.response?.data?.message ||
        "Unable to load computers."
      );
    } finally {
      setLoading(false);
    }
  }, []);

  // ============================================================
  // INITIAL LOAD
  // ============================================================

  useEffect(() => {
    loadComputers();
  }, [loadComputers]);

  // ============================================================
  // FORM CHANGE
  // ============================================================

  const handleChange = (e) => {
    const { name, value } = e.target;

    setForm((previous) => ({
      ...previous,

      [name]:
        name === "computer_code"
          ? value.toUpperCase()
          : value,
    }));
  };

  // ============================================================
  // CREATE COMPUTER
  // ============================================================

  const handleCreate = async (e) => {
    e.preventDefault();

    setMessage("");
    setError("");

    const computerCode = form.computer_code
      .trim()
      .toUpperCase();

    const password = form.password;

    if (!computerCode) {
      setError("Computer ID is required.");
      return;
    }

    if (password.length < 4) {
      setError(
        "Password must be at least 4 characters."
      );
      return;
    }

    try {
      setCreating(true);

      const data = await shopService.createComputer({
        computer_code: computerCode,
        password,
      });

      setMessage(
        data?.message ||
        "Computer created successfully."
      );

      setForm({
        computer_code: "",
        password: "",
      });

      await loadComputers();
    } catch (err) {
      console.error("Create Computer Error:", err);

      setError(
        err?.response?.data?.message ||
        "Unable to create computer."
      );
    } finally {
      setCreating(false);
    }
  };

  // ============================================================
  // UPDATE STATUS
  // ============================================================

  const handleStatus = async (computer) => {
    const newStatus =
      computer.status === "ACTIVE"
        ? "BLOCKED"
        : "ACTIVE";

    try {
      setMessage("");
      setError("");

      const data =
        await shopService.updateComputerStatus(
          computer.id,
          newStatus
        );

      setMessage(
        data?.message ||
        "Computer status updated successfully."
      );

      await loadComputers();
    } catch (err) {
      console.error(
        "Computer Status Error:",
        err
      );

      setError(
        err?.response?.data?.message ||
        "Unable to update computer status."
      );
    }
  };

  // ============================================================
  // OPEN PASSWORD MODAL
  // ============================================================

  const openPasswordModal = (computer) => {
    setPasswordModal(computer);
    setNewPassword("");
    setMessage("");
    setError("");
  };

  // ============================================================
  // CLOSE PASSWORD MODAL
  // ============================================================

  const closePasswordModal = () => {
    setPasswordModal(null);
    setNewPassword("");
  };

  // ============================================================
  // CHANGE PASSWORD
  // ============================================================

  const handlePasswordChange = async (e) => {
    e.preventDefault();

    if (!passwordModal) {
      return;
    }

    if (newPassword.length < 4) {
      setError(
        "Password must be at least 4 characters."
      );
      return;
    }

    try {
      setPasswordUpdating(true);
      setError("");

      const data =
        await shopService.changeComputerPassword(
          passwordModal.id,
          newPassword
        );

      closePasswordModal();

      setMessage(
        data?.message ||
        "Computer password changed successfully."
      );
    } catch (err) {
      console.error(
        "Password Update Error:",
        err
      );

      setError(
        err?.response?.data?.message ||
        "Unable to change computer password."
      );
    } finally {
      setPasswordUpdating(false);
    }
  };

  // ============================================================
  // FORMAT DATE
  // ============================================================

  const formatDate = (value) => {
    if (!value) {
      return "-";
    }

    const date = new Date(value);

    if (Number.isNaN(date.getTime())) {
      return "-";
    }

    return date.toLocaleString("en-IN");
  };

  // ============================================================
  // UI
  // ============================================================

  return (
    <div className="flex min-h-screen flex-col bg-[#070A12] text-[#F8FAFC]">
      {/* ====================================================== */}
      {/* NAVBAR */}
      {/* ====================================================== */}

      <Navbar toggleSidebar={toggleSidebar} />

      {/* ====================================================== */}
      {/* BODY */}
      {/* ====================================================== */}

      <div className="relative flex flex-1">
        {/* ==================================================== */}
        {/* SIDEBAR */}
        {/* ==================================================== */}

        <Sidebar
          isOpen={sidebarOpen}
          closeMobileSidebar={closeSidebar}
        />

        {/* ==================================================== */}
        {/* MAIN CONTENT */}
        {/* ==================================================== */}

        <main className="min-w-0 flex-1 overflow-auto bg-[#070A12]">
          <div className="mx-auto w-full max-w-[1540px] px-4 py-6 sm:px-6 lg:px-8">
            {/* ================================================= */}
            {/* PAGE HEADER */}
            {/* ================================================= */}

            <div className="mb-6">
              <h1 className="text-2xl font-bold tracking-tight text-[#F8FAFC] sm:text-3xl">
                Computer Management
              </h1>

              <p className="mt-1 text-sm text-[#94A3B8]">
                Create and manage computer accounts.
              </p>
            </div>

            {/* ================================================= */}
            {/* SUCCESS MESSAGE */}
            {/* ================================================= */}

            {message && (
              <div className="mb-5 rounded-xl border border-[#22C55E]/30 bg-[#22C55E]/10 px-4 py-3 text-sm font-medium text-[#4ADE80]">
                <div className="flex items-center gap-2">
                  <i className="bi bi-check-circle-fill" />

                  <span>{message}</span>
                </div>
              </div>
            )}

            {/* ================================================= */}
            {/* ERROR MESSAGE */}
            {/* ================================================= */}

            {error && (
              <div className="mb-5 rounded-xl border border-red-500/30 bg-red-500/10 px-4 py-3 text-sm font-medium text-red-400">
                <div className="flex items-center gap-2">
                  <i className="bi bi-exclamation-circle-fill" />

                  <span>{error}</span>
                </div>
              </div>
            )}

            {/* ================================================= */}
            {/* CREATE COMPUTER CARD */}
            {/* ================================================= */}

            <div className="mb-4 sm:mb-6 overflow-hidden rounded-xl sm:rounded-2xl border border-[rgba(148,163,184,0.14)] bg-[#121827]">
              {/* CARD HEADER */}

              <div className="border-b border-[rgba(148,163,184,0.14)] px-3.5 py-3 sm:px-5 sm:py-4">
                <div className="flex items-center gap-2.5 sm:gap-3">
                  <div className="flex h-8 w-8 sm:h-10 sm:w-10 items-center justify-center rounded-lg sm:rounded-xl border border-[#D4AF37]/30 bg-[#D4AF37]/10 text-[#D4AF37]">
                    <i className="bi bi-pc-display text-sm sm:text-lg" />
                  </div>

                  <div>
                    <h2 className="text-sm sm:text-base font-bold text-[#F8FAFC]">
                      Create Computer
                    </h2>

                    <p className="mt-0.5 text-[11px] sm:text-xs text-[#94A3B8]">
                      Create a fixed Computer ID and password.
                    </p>
                  </div>
                </div>
              </div>

              {/* CREATE FORM */}

              <form
                onSubmit={handleCreate}
                className="grid grid-cols-1 gap-3 p-3.5 sm:gap-4 sm:p-5 md:grid-cols-3"
              >
                {/* COMPUTER ID */}

                <div>
                  <label className="mb-1.5 sm:mb-2 block text-[10px] sm:text-xs font-semibold uppercase tracking-wide text-[#94A3B8]">
                    Computer ID
                  </label>

                  <div className="relative">
                    <i className="bi bi-pc-display absolute left-3 top-1/2 -translate-y-1/2 text-xs sm:text-sm text-[#64748B]" />

                    <input
                      type="text"
                      name="computer_code"
                      value={form.computer_code}
                      onChange={handleChange}
                      placeholder="PC-05"
                      autoComplete="off"
                      className="
                        w-full rounded-lg sm:rounded-xl
                        border border-[rgba(148,163,184,0.18)]
                        bg-[#0D111C]
                        py-2 pl-9 pr-3 sm:py-2.5 sm:pl-10 sm:pr-4
                        text-xs sm:text-sm text-[#F8FAFC]
                        outline-none
                        transition
                        placeholder:text-[#475569]
                        focus:border-[#D4AF37]/60
                        focus:ring-2
                        focus:ring-[#D4AF37]/10
                      "
                    />
                  </div>
                </div>

                {/* PASSWORD */}

                <div>
                  <label className="mb-1.5 sm:mb-2 block text-[10px] sm:text-xs font-semibold uppercase tracking-wide text-[#94A3B8]">
                    Password
                  </label>

                  <div className="relative">
                    <i className="bi bi-lock-fill absolute left-3 top-1/2 -translate-y-1/2 text-xs sm:text-sm text-[#64748B]" />

                    <input
                      type="password"
                      name="password"
                      value={form.password}
                      onChange={handleChange}
                      placeholder="Enter password"
                      autoComplete="new-password"
                      className="
                        w-full rounded-lg sm:rounded-xl
                        border border-[rgba(148,163,184,0.18)]
                        bg-[#0D111C]
                        py-2 pl-9 pr-3 sm:py-2.5 sm:pl-10 sm:pr-4
                        text-xs sm:text-sm text-[#F8FAFC]
                        outline-none
                        transition
                        placeholder:text-[#475569]
                        focus:border-[#D4AF37]/60
                        focus:ring-2
                        focus:ring-[#D4AF37]/10
                      "
                    />
                  </div>
                </div>

                {/* CREATE BUTTON */}

                <div className="flex items-end pt-1 sm:pt-0">
                  <button
                    type="submit"
                    disabled={creating}
                    className="
                      flex w-full items-center
                      justify-center gap-2
                      rounded-lg sm:rounded-xl
                      bg-gradient-to-r
                      from-[#D4AF37]
                      to-[#AA7C11]
                      px-4 py-2 sm:px-5 sm:py-2.5
                      text-xs sm:text-sm font-bold
                      text-[#070A12]
                      transition
                      hover:opacity-90
                      disabled:cursor-not-allowed
                      disabled:opacity-50
                    "
                  >
                    {creating ? (
                      <>
                        <span className="h-3.5 w-3.5 sm:h-4 sm:w-4 animate-spin rounded-full border-2 border-[#070A12]/30 border-t-[#070A12]" />

                        Creating...
                      </>
                    ) : (
                      <>
                        <i className="bi bi-plus-circle-fill text-xs sm:text-sm" />

                        Create Computer
                      </>
                    )}
                  </button>
                </div>
              </form>
            </div>

            {/* ================================================= */}
            {/* COMPUTER LIST */}
            {/* ================================================= */}

            <div className="overflow-hidden rounded-2xl border border-[rgba(148,163,184,0.14)] bg-[#121827]">
              {/* TABLE HEADER */}

              <div className="flex flex-col gap-3 border-b border-[rgba(148,163,184,0.14)] px-5 py-4 sm:flex-row sm:items-center sm:justify-between">
                <div>
                  <h2 className="text-base font-bold text-[#F8FAFC]">
                    Computers
                  </h2>

                  <p className="mt-1 text-xs text-[#94A3B8]">
                    Total Computers:{" "}
                    <span className="font-bold text-[#D4AF37]">
                      {computers.length}
                    </span>
                  </p>
                </div>

                <button
                  type="button"
                  onClick={loadComputers}
                  disabled={loading}
                  className="
                    inline-flex items-center
                    justify-center gap-2
                    rounded-lg
                    border
                    border-[rgba(148,163,184,0.18)]
                    bg-[#0D111C]
                    px-4 py-2
                    text-xs font-semibold
                    text-[#94A3B8]
                    transition
                    hover:border-[#D4AF37]/40
                    hover:text-[#F8FAFC]
                    disabled:opacity-50
                  "
                >
                  <i
                    className={`bi bi-arrow-clockwise ${loading ? "animate-spin" : ""
                      }`}
                  />

                  Refresh
                </button>
              </div>

              {/* DESKTOP TABLE VIEW (SHOWN ON LAPTOP / DESKTOP) */}
              <div className="hidden sm:block overflow-x-auto">
                <table className="w-full min-w-[850px] text-left">
                  <thead className="bg-[#0D111C]">
                    <tr>
                      <th className="px-5 py-3 text-[10px] font-bold uppercase tracking-wider text-[#64748B]">
                        Sr No
                      </th>

                      <th className="px-5 py-3 text-[10px] font-bold uppercase tracking-wider text-[#64748B]">
                        Computer ID
                      </th>

                      <th className="px-5 py-3 text-[10px] font-bold uppercase tracking-wider text-[#64748B]">
                        Status
                      </th>

                      <th className="px-5 py-3 text-[10px] font-bold uppercase tracking-wider text-[#64748B]">
                        Created Date
                      </th>

                      <th className="px-5 py-3 text-[10px] font-bold uppercase tracking-wider text-[#64748B]">
                        Actions
                      </th>
                    </tr>
                  </thead>

                  <tbody className="divide-y divide-[rgba(148,163,184,0.10)]">
                    {/* LOADING */}

                    {loading ? (
                      <tr>
                        <td
                          colSpan="5"
                          className="px-5 py-12 text-center"
                        >
                          <div className="flex flex-col items-center justify-center gap-3 text-[#94A3B8]">
                            <span className="h-7 w-7 animate-spin rounded-full border-2 border-[#D4AF37]/20 border-t-[#D4AF37]" />

                            <span className="text-xs">
                              Loading computers...
                            </span>
                          </div>
                        </td>
                      </tr>
                    ) : computers.length === 0 ? (
                      /* EMPTY */

                      <tr>
                        <td
                          colSpan="5"
                          className="px-5 py-12 text-center"
                        >
                          <div className="flex flex-col items-center justify-center">
                            <div className="mb-3 flex h-12 w-12 items-center justify-center rounded-xl bg-[#0D111C] text-[#64748B]">
                              <i className="bi bi-pc-display text-xl" />
                            </div>

                            <p className="text-sm font-semibold text-[#F8FAFC]">
                              No Computers
                            </p>

                            <p className="mt-1 text-xs text-[#64748B]">
                              Create your first computer
                              account above.
                            </p>
                          </div>
                        </td>
                      </tr>
                    ) : (
                      /* COMPUTER ROWS */

                      computers.map(
                        (computer, index) => (
                          <tr
                            key={computer.id}
                            className="transition hover:bg-white/[0.02]"
                          >
                            {/* SR */}

                            <td className="px-5 py-4 text-xs text-[#94A3B8]">
                              {index + 1}
                            </td>

                            {/* COMPUTER */}

                            <td className="px-5 py-4">
                              <div className="flex items-center gap-3">
                                <div className="flex h-9 w-9 items-center justify-center rounded-lg border border-[#D4AF37]/20 bg-[#D4AF37]/10 text-[#D4AF37]">
                                  <i className="bi bi-pc-display" />
                                </div>

                                <div>
                                  <p className="text-sm font-bold text-[#F8FAFC]">
                                    {
                                      computer.computer_code
                                    }
                                  </p>

                                  <p className="mt-0.5 text-[10px] text-[#64748B]">
                                    ID: {computer.id}
                                  </p>
                                </div>
                              </div>
                            </td>

                            {/* STATUS & WALLET */}

                            <td className="px-5 py-4">
                              <div className="flex flex-col gap-1.5 items-start">
                                <span
                                  className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 py-1 text-[10px] font-bold ${computer.status ===
                                      "ACTIVE"
                                      ? "border-[#22C55E]/20 bg-[#22C55E]/10 text-[#4ADE80]"
                                      : "border-red-500/20 bg-red-500/10 text-red-400"
                                    }`}
                                >
                                  <span
                                    className={`h-1.5 w-1.5 rounded-full ${computer.status ===
                                        "ACTIVE"
                                        ? "bg-[#22C55E]"
                                        : "bg-red-500"
                                      }`}
                                  />

                                  {computer.status}
                                </span>

                                <span className="text-xs font-bold text-[#D4AF37]">
                                  🪙 {Number(computer.wallet ?? computer.coins ?? computer.current_balance ?? computer.balance ?? computer.credits ?? 0).toLocaleString("en-IN")}
                                </span>
                              </div>
                            </td>

                            {/* CREATED */}

                            <td className="px-5 py-4 text-xs text-[#94A3B8]">
                              {formatDate(
                                computer.created_at
                              )}
                            </td>

                            {/* ACTIONS */}

                            <td className="px-5 py-4">
                              <div className="flex flex-wrap gap-2">
                                {/* PASSWORD */}

                                <button
                                  type="button"
                                  onClick={() =>
                                    openPasswordModal(
                                      computer
                                    )
                                  }
                                  className="
                                    inline-flex items-center
                                    gap-1.5 rounded-lg
                                    border
                                    border-[rgba(148,163,184,0.18)]
                                    bg-[#0D111C]
                                    px-3 py-2
                                    text-[10px]
                                    font-semibold
                                    text-[#CBD5E1]
                                    transition
                                    hover:border-[#D4AF37]/40
                                    hover:text-[#D4AF37]
                                  "
                                >
                                  <i className="bi bi-key-fill" />

                                  Change Password
                                </button>

                                {/* TRANSFER COINS */}

                                <button
                                  type="button"
                                  onClick={() =>
                                    openTransferModal(
                                      computer
                                    )
                                  }
                                  className="
                                    inline-flex items-center
                                    gap-1.5 rounded-lg
                                    border
                                    border-[rgba(34,197,94,0.3)]
                                    bg-[#22C55E]/10
                                    px-3 py-2
                                    text-[10px]
                                    font-semibold
                                    text-[#4ADE80]
                                    transition
                                    hover:bg-[#22C55E]/20
                                    hover:text-white
                                  "
                                >
                                  <i className="bi bi-arrow-left-right" />

                                  Transfer Coins
                                </button>

                                {/* STATUS */}

                                <button
                                  type="button"
                                  onClick={() =>
                                    handleStatus(
                                      computer
                                    )
                                  }
                                  className={`inline-flex items-center gap-1.5 rounded-lg border px-3 py-2 text-[10px] font-semibold transition ${computer.status ===
                                      "ACTIVE"
                                      ? "border-red-500/20 bg-red-500/10 text-red-400 hover:bg-red-500/20"
                                      : "border-[#22C55E]/20 bg-[#22C55E]/10 text-[#4ADE80] hover:bg-[#22C55E]/20"
                                    }`}
                                >
                                  <i
                                    className={`bi ${computer.status ===
                                        "ACTIVE"
                                        ? "bi-slash-circle-fill"
                                        : "bi-check-circle-fill"
                                      }`}
                                  />

                                  {computer.status ===
                                    "ACTIVE"
                                    ? "Block"
                                    : "Activate"}
                                </button>

                                {/* RESET DEVICE LOCK */}

                                <button
                                  type="button"
                                  onClick={() =>
                                    handleResetDeviceLock(
                                      computer
                                    )
                                  }
                                  className="inline-flex items-center gap-1.5 rounded-lg border border-amber-500/30 bg-amber-500/10 px-3 py-2 text-[10px] font-semibold text-amber-400 transition hover:bg-amber-500/20"
                                >
                                  <i className="bi bi-unlock-fill" />

                                  Reset Device Lock
                                </button>

                                {/* DELETE COMPUTER */}

                                <button
                                  type="button"
                                  onClick={() => setComputerToDelete(computer)}
                                  className="inline-flex items-center gap-1.5 rounded-lg border border-red-500/30 bg-red-500/10 px-3 py-2 text-[10px] font-semibold text-red-400 transition hover:bg-red-500/20"
                                >
                                  <i className="bi bi-trash-fill" />

                                  Delete
                                </button>
                              </div>
                            </td>
                          </tr>
                        )
                      )
                    )}
                  </tbody>
                </table>
              </div>

              {/* MOBILE CARDS VIEW (SHOWN ONLY ON MOBILE) */}
              <div className="block sm:hidden">
                {loading ? (
                  <div className="px-4 py-10 text-center">
                    <div className="flex flex-col items-center justify-center gap-2 text-[#94A3B8]">
                      <span className="h-6 w-6 animate-spin rounded-full border-2 border-[#D4AF37]/20 border-t-[#D4AF37]" />
                      <span className="text-xs">Loading computers...</span>
                    </div>
                  </div>
                ) : computers.length === 0 ? (
                  <div className="px-4 py-10 text-center">
                    <div className="mb-2 flex h-10 w-10 mx-auto items-center justify-center rounded-xl bg-[#0D111C] text-[#64748B]">
                      <i className="bi bi-pc-display text-lg" />
                    </div>
                    <p className="text-sm font-semibold text-[#F8FAFC]">No Computers</p>
                    <p className="mt-0.5 text-xs text-[#64748B]">
                      Create your first computer account above.
                    </p>
                  </div>
                ) : (
                  <div className="p-3 space-y-3">
                    {computers.map((computer, index) => {
                      const compBal = Number(
                        computer.wallet ??
                          computer.coins ??
                          computer.current_balance ??
                          computer.balance ??
                          computer.credits ??
                          0
                      ).toLocaleString("en-IN");

                      return (
                        <div
                          key={computer.id}
                          className="rounded-xl border border-[rgba(148,163,184,0.14)] bg-[#0D111C] p-3.5 space-y-3"
                        >
                          {/* Header: Computer Code + Status & Wallet */}
                          <div className="flex items-start justify-between gap-2">
                            <div className="flex items-center gap-2.5">
                              <div className="flex h-9 w-9 items-center justify-center rounded-lg border border-[#D4AF37]/20 bg-[#D4AF37]/10 text-[#D4AF37]">
                                <i className="bi bi-pc-display" />
                              </div>
                              <div>
                                <p className="text-sm font-extrabold text-[#F8FAFC]">
                                  {computer.computer_code}
                                </p>
                                <p className="text-[10px] text-[#64748B]">
                                  ID: {computer.id} · #{index + 1}
                                </p>
                              </div>
                            </div>

                            <div className="flex flex-col items-end gap-1">
                              <span
                                className={`inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-[9px] font-bold ${
                                  computer.status === "ACTIVE"
                                    ? "border-[#22C55E]/20 bg-[#22C55E]/10 text-[#4ADE80]"
                                    : "border-red-500/20 bg-red-500/10 text-red-400"
                                }`}
                              >
                                <span
                                  className={`h-1.5 w-1.5 rounded-full ${
                                    computer.status === "ACTIVE"
                                      ? "bg-[#22C55E]"
                                      : "bg-red-500"
                                  }`}
                                />
                                {computer.status}
                              </span>

                              <span className="text-xs font-extrabold text-[#D4AF37]">
                                🪙 {compBal}
                              </span>
                            </div>
                          </div>

                          {/* Sub-info: Date */}
                          <div className="flex items-center justify-between border-t border-[rgba(148,163,184,0.08)] pt-2 text-[10px] text-[#94A3B8]">
                            <span>Created: {formatDate(computer.created_at)}</span>
                          </div>

                          {/* Mobile Actions Grid (2x2) */}
                          <div className="grid grid-cols-2 gap-2 pt-1">
                            <button
                              type="button"
                              onClick={() => openTransferModal(computer)}
                              className="inline-flex items-center justify-center gap-1.5 rounded-lg border border-[#22C55E]/30 bg-[#22C55E]/10 py-2 text-[10px] font-semibold text-[#4ADE80] transition hover:bg-[#22C55E]/20"
                            >
                              <i className="bi bi-arrow-left-right" />
                              Transfer Coins
                            </button>

                            <button
                              type="button"
                              onClick={() => openPasswordModal(computer)}
                              className="inline-flex items-center justify-center gap-1.5 rounded-lg border border-[rgba(148,163,184,0.18)] bg-[#121827] py-2 text-[10px] font-semibold text-[#CBD5E1] transition hover:border-[#D4AF37]/40 hover:text-[#D4AF37]"
                            >
                              <i className="bi bi-key-fill" />
                              Password
                            </button>

                            <button
                              type="button"
                              onClick={() => handleStatus(computer)}
                              className={`inline-flex items-center justify-center gap-1.5 rounded-lg border py-2 text-[10px] font-semibold transition ${
                                computer.status === "ACTIVE"
                                  ? "border-red-500/20 bg-red-500/10 text-red-400 hover:bg-red-500/20"
                                  : "border-[#22C55E]/20 bg-[#22C55E]/10 text-[#4ADE80] hover:bg-[#22C55E]/20"
                              }`}
                            >
                              <i
                                className={`bi ${
                                  computer.status === "ACTIVE"
                                    ? "bi-slash-circle-fill"
                                    : "bi-check-circle-fill"
                                }`}
                              />
                              {computer.status === "ACTIVE" ? "Block" : "Activate"}
                            </button>

                            <button
                              type="button"
                              onClick={() => handleResetDeviceLock(computer)}
                              className="inline-flex items-center justify-center gap-1.5 rounded-lg border border-amber-500/30 bg-amber-500/10 py-2 text-[10px] font-semibold text-amber-400 transition hover:bg-amber-500/20"
                            >
                              <i className="bi bi-unlock-fill" />
                              Reset Lock
                            </button>

                            <button
                              type="button"
                              onClick={() => setComputerToDelete(computer)}
                              className="col-span-2 inline-flex items-center justify-center gap-1.5 rounded-lg border border-red-500/30 bg-red-500/10 py-2 text-[10px] font-semibold text-red-400 transition hover:bg-red-500/20"
                            >
                              <i className="bi bi-trash-fill" />
                              Delete Computer
                            </button>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>
            </div>
          </div>
        </main>
      </div>

      {/* ====================================================== */}
      {/* CHANGE PASSWORD MODAL */}
      {/* ====================================================== */}

      {passwordModal && (
        <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/75 p-4 backdrop-blur-sm">
          <div className="w-full max-w-md overflow-hidden rounded-2xl border border-[rgba(148,163,184,0.16)] bg-[#121827] shadow-2xl">
            {/* MODAL HEADER */}

            <div className="flex items-center justify-between border-b border-[rgba(148,163,184,0.14)] px-5 py-4">
              <div>
                <h2 className="text-base font-bold text-[#F8FAFC]">
                  Change Password
                </h2>

                <p className="mt-1 text-xs text-[#94A3B8]">
                  Computer:{" "}
                  <span className="font-bold text-[#D4AF37]">
                    {passwordModal.computer_code}
                  </span>
                </p>
              </div>

              <button
                type="button"
                onClick={closePasswordModal}
                className="flex h-8 w-8 items-center justify-center rounded-lg text-[#64748B] transition hover:bg-white/5 hover:text-[#F8FAFC]"
              >
                <i className="bi bi-x-lg" />
              </button>
            </div>

            {/* MODAL FORM */}

            <form
              onSubmit={handlePasswordChange}
              className="p-5"
            >
              <label className="mb-2 block text-xs font-semibold uppercase tracking-wide text-[#94A3B8]">
                New Password
              </label>

              <div className="relative">
                <i className="bi bi-lock-fill absolute left-3 top-1/2 -translate-y-1/2 text-[#64748B]" />

                <input
                  type="password"
                  value={newPassword}
                  onChange={(e) =>
                    setNewPassword(e.target.value)
                  }
                  autoFocus
                  autoComplete="new-password"
                  placeholder="Enter new password"
                  className="
                    w-full rounded-xl
                    border border-[rgba(148,163,184,0.18)]
                    bg-[#0D111C]
                    py-2.5 pl-10 pr-4
                    text-sm text-[#F8FAFC]
                    outline-none
                    placeholder:text-[#475569]
                    focus:border-[#D4AF37]/60
                    focus:ring-2
                    focus:ring-[#D4AF37]/10
                  "
                />
              </div>

              <p className="mt-2 text-[10px] text-[#64748B]">
                Password must contain at least 4
                characters.
              </p>

              {/* MODAL BUTTONS */}

              <div className="mt-6 flex justify-end gap-3">
                <button
                  type="button"
                  onClick={closePasswordModal}
                  className="
                    rounded-lg
                    border
                    border-[rgba(148,163,184,0.18)]
                    bg-[#0D111C]
                    px-4 py-2
                    text-xs font-semibold
                    text-[#94A3B8]
                    transition
                    hover:text-[#F8FAFC]
                  "
                >
                  Cancel
                </button>

                <button
                  type="submit"
                  disabled={passwordUpdating}
                  className="
                    inline-flex items-center
                    gap-2
                    rounded-lg
                    bg-gradient-to-r
                    from-[#D4AF37]
                    to-[#AA7C11]
                    px-4 py-2
                    text-xs font-bold
                    text-[#070A12]
                    transition
                    hover:opacity-90
                    disabled:opacity-50
                  "
                >
                  {passwordUpdating ? (
                    <>
                      <span className="h-3.5 w-3.5 animate-spin rounded-full border-2 border-[#070A12]/30 border-t-[#070A12]" />

                      Updating...
                    </>
                  ) : (
                    <>
                      <i className="bi bi-key-fill" />

                      Update Password
                    </>
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* ====================================================== */}
      {/* TRANSFER COINS MODAL */}
      {/* ====================================================== */}

      {transferModal && (
        <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/75 p-4 backdrop-blur-sm">
          <div className="w-full max-w-md overflow-hidden rounded-2xl border border-[rgba(148,163,184,0.16)] bg-[#121827] shadow-2xl">
            <div className="flex items-center justify-between border-b border-[rgba(148,163,184,0.14)] px-5 py-4">
              <div>
                <h2 className="text-base font-bold text-[#F8FAFC]">
                  Transfer Coins to Computer
                </h2>
                <p className="mt-1 text-xs text-[#94A3B8]">
                  Computer ID:{" "}
                  <span className="font-bold text-[#D4AF37]">
                    {transferModal.computer_code}
                  </span>
                </p>
              </div>
              <button
                type="button"
                onClick={closeTransferModal}
                className="flex h-8 w-8 items-center justify-center rounded-lg text-[#64748B] transition hover:bg-white/5 hover:text-[#F8FAFC]"
              >
                <i className="bi bi-x-lg" />
              </button>
            </div>

            <form onSubmit={handleTransferCoins} className="p-5">
              <label className="mb-2 block text-xs font-semibold uppercase tracking-wide text-[#94A3B8]">
                Coin Amount
              </label>
              <div className="relative">
                <i className="bi bi-coin absolute left-3 top-1/2 -translate-y-1/2 text-[#D4AF37]" />
                <input
                  type="number"
                  min="1"
                  step="any"
                  value={transferAmount}
                  onChange={(e) => setTransferAmount(e.target.value)}
                  autoFocus
                  placeholder="Enter coin amount"
                  className="w-full rounded-xl border border-[rgba(148,163,184,0.18)] bg-[#0D111C] py-2.5 pl-10 pr-4 text-sm text-[#F8FAFC] outline-none placeholder:text-[#475569] focus:border-[#D4AF37]/60 focus:ring-2 focus:ring-[#D4AF37]/10"
                />
              </div>
              <p className="mt-2 text-[10px] text-[#64748B]">
                Coins will be transferred directly from your Shop wallet to this computer.
              </p>

              <div className="mt-6 flex justify-end gap-3">
                <button
                  type="button"
                  onClick={closeTransferModal}
                  className="rounded-lg border border-[rgba(148,163,184,0.18)] bg-[#0D111C] px-4 py-2 text-xs font-semibold text-[#94A3B8] transition hover:text-[#F8FAFC]"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  disabled={transferringCoins}
                  className="inline-flex items-center gap-2 rounded-lg bg-gradient-to-r from-[#D4AF37] to-[#AA7C11] px-4 py-2 text-xs font-bold text-[#070A12] transition hover:opacity-90 disabled:opacity-50"
                >
                  {transferringCoins ? (
                    <>
                      <span className="h-3.5 w-3.5 animate-spin rounded-full border-2 border-[#070A12]/30 border-t-[#070A12]" />
                      Transferring...
                    </>
                  ) : (
                    <>
                      <i className="bi bi-send-fill" />
                      Transfer Coins
                    </>
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
      {/* ====================================================== */}
      {/* DELETE COMPUTER CONFIRMATION MODAL */}
      {/* ====================================================== */}

      {computerToDelete && (
        <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/75 p-4 backdrop-blur-sm">
          <div className="w-full max-w-md overflow-hidden rounded-2xl border border-red-500/30 bg-[#121827] shadow-2xl">
            {/* MODAL HEADER */}
            <div className="flex items-center justify-between border-b border-[rgba(148,163,184,0.14)] px-5 py-4">
              <div className="flex items-center gap-2.5">
                <div className="flex h-9 w-9 items-center justify-center rounded-xl bg-red-500/10 text-red-400 border border-red-500/30">
                  <i className="bi bi-exclamation-triangle-fill text-lg" />
                </div>
                <div>
                  <h2 className="text-base font-bold text-[#F8FAFC]">
                    Confirm Delete Computer
                  </h2>
                  <p className="mt-0.5 text-[11px] text-[#94A3B8]">
                    Permanent removal from your Shop
                  </p>
                </div>
              </div>

              <button
                type="button"
                onClick={() => setComputerToDelete(null)}
                disabled={deletingComputer}
                className="flex h-8 w-8 items-center justify-center rounded-lg text-[#94A3B8] transition hover:bg-white/[0.05] hover:text-[#F8FAFC]"
              >
                <i className="bi bi-x-lg text-sm" />
              </button>
            </div>

            {/* MODAL BODY */}
            <div className="p-5 text-center">
              <div className="mb-3">
                <div className="inline-flex h-14 w-14 items-center justify-center rounded-2xl bg-red-500/10 text-red-400 border border-red-500/20">
                  <i className="bi bi-trash fs-2 text-2xl" />
                </div>
              </div>

              <h6 className="font-bold text-base text-[#F8FAFC] mb-2">
                Delete "{computerToDelete.computer_code}"?
              </h6>

              <p className="text-xs text-[#94A3B8] mb-4 leading-relaxed">
                Are you sure you want to permanently delete this computer terminal?
                All related records (sessions, bets, and transaction history) for this computer will be permanently removed.
              </p>

              <div className="rounded-xl border border-[rgba(148,163,184,0.14)] bg-[#0D111C] p-3 text-left text-xs space-y-1.5">
                <div className="flex justify-between">
                  <span className="text-[#64748B]">Computer ID:</span>
                  <span className="font-bold text-[#F8FAFC]">#{computerToDelete.id}</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-[#64748B]">Terminal Code:</span>
                  <span className="font-bold text-[#D4AF37]">{computerToDelete.computer_code}</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-[#64748B]">Balance:</span>
                  <span className="font-bold text-emerald-400">
                    🪙 {Number(computerToDelete.wallet ?? computerToDelete.coins ?? computerToDelete.current_balance ?? computerToDelete.balance ?? 0).toLocaleString("en-IN")}
                  </span>
                </div>
              </div>

              <div className="mt-5 flex justify-end gap-3">
                <button
                  type="button"
                  disabled={deletingComputer}
                  onClick={() => setComputerToDelete(null)}
                  className="rounded-lg border border-[rgba(148,163,184,0.18)] bg-[#0D111C] px-4 py-2 text-xs font-semibold text-[#94A3B8] transition hover:text-[#F8FAFC]"
                >
                  Cancel
                </button>
                <button
                  type="button"
                  disabled={deletingComputer}
                  onClick={() => handleDeleteComputer(computerToDelete)}
                  className="inline-flex items-center gap-2 rounded-lg bg-red-600 hover:bg-red-700 px-4 py-2 text-xs font-bold text-white transition disabled:opacity-50"
                >
                  {deletingComputer ? (
                    <>
                      <span className="h-3.5 w-3.5 animate-spin rounded-full border-2 border-white/30 border-t-white" />
                      Deleting...
                    </>
                  ) : (
                    <>
                      <i className="bi bi-trash-fill" />
                      Yes, Delete
                    </>
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Computers;